import { render, staticRenderFns } from "./QNoticesSubmenu.vue?vue&type=template&id=5c10a1cc&"
import script from "./QNoticesSubmenu.vue?vue&type=script&lang=js&"
export * from "./QNoticesSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports